// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"

import hljs from "highlight.js/lib/core"
import gdscript from "@exercism/highlightjs-gdscript"

hljs.registerLanguage("gdscript", gdscript)

document.addEventListener("turbo:load", () => hljs.highlightAll())
